/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_ContactInputs */

const fr_about_contact = /** @type {(inputs: About_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un bug ? Une suggestion ? Une remarque ou une question ?`)
};

const en_about_contact = /** @type {(inputs: About_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found a bug? Have a suggestion, comment, or question?`)
};

/**
* | output |
* | --- |
* | "Found a bug? Have a suggestion, comment, or question?" |
*
* @param {About_ContactInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const about_contact = /** @type {((inputs?: About_ContactInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_ContactInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_contact(inputs)
	return en_about_contact(inputs)
});